import apiClient from '@/lib/api-client';

export interface AttentionProduct {
  id: string;
  gtin: string;
  name: string;
  brand: string;
  brandId: string | null;
  score: number;
  missingRequiredFieldCount: number;
  lastUpdated: string;
}

export async function getAttentionProducts(gln: string): Promise<{ data: AttentionProduct[] }> {
  const params = new URLSearchParams({ gln, limit: '5' });
  const response = await apiClient.get<{ data: AttentionProduct[] }>(
    `/completeness/attention?${params.toString()}`,
  );
  return response.data;
}
